import { render, staticRenderFns } from "./purchaseOrder.vue?vue&type=template&id=c4875254&scoped=true"
import script from "./purchaseOrder.vue?vue&type=script&lang=js"
export * from "./purchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrder.vue?vue&type=style&index=0&id=c4875254&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4875254",
  null
  
)

export default component.exports